import { Link, useLocation } from 'react-router-dom';

const nameMap: Record<string, string> = {
  category: '资源中心',
  article: '文章详情',
  about: '关于我们',
  all: '全部',
  tutorial: '使用教程',
  feature: '功能介绍',
  activity: '最新活动',
  case: '用户案例',
  news: '平台动态',
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  const items: { label: string; path: string }[] = [{ label: '首页', path: '/' }];

  let currentPath = '';
  for (const seg of segments) {
    currentPath += `/${seg}`;
    items.push({ label: nameMap[seg] || seg, path: currentPath });
  }

  return (
    <nav aria-label="面包屑导航" className="px-6 md:px-12 py-3">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        {items.map((item, i) => (
          <li key={item.path} className="flex items-center gap-1.5">
            {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400" />}
            {i < items.length - 1 ? (
              <Link
                to={item.path}
                className="hover:text-primary-500 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}